module.exports = __webpack_public_path__ + "img/empty_shopping_cart@4x.12a295ac.png";